/* eslint-disable import/prefer-default-export */
import { all, takeLatest, call, put } from "redux-saga/effects";
import API, { responseParser } from "../../services/api";
import {
  FETCH_USERS,
  SET_USERS,
  FETCH_CONTROLLERS,
  SET_CONTROLLERS,
  SET_USER_CONTROLLERS,
  FETCH_USER_CONTROLLERS,
  UPDATE_OTA,
  SET_OTA,
  ADD_CONTROLLER,
  SET_NEW_CONTROLLER,
  SET_UPDATE_CONTROLLER,
  UPDATE_CONTROLLER,
  SET_INVOICE,
  FETCH_INVOICE,
  FACTORY_RESET,
} from "./types";
const api = API.create();

function* getUsers() {
  const response = yield call(api.fetchUsers);
  const result = responseParser(response);
  if (Array.isArray(result) && result.length) {
    yield put({ type: SET_USERS, payload: result });
  }
}

function* getController() {
  const response = yield call(api.fetchControllers);
  const result = responseParser(response);
  if (Array.isArray(result) && result.length) {
    yield put({ type: SET_CONTROLLERS, payload: result });
  }
}

function* getUserController() {
  const response = yield call(api.fetchUserControllers);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_USER_CONTROLLERS, payload: result });
  }
}

function* updateControllerOta({ payload }) {
  const response = yield call(api.updateOta, payload);
  const result = responseParser(
    response,
    "Error while updating OTA",
    "",
    true,
    true
  );
  if (result) {
    yield put({ type: SET_OTA, payload: result });
  }
}

function* addController({ payload }) {
  const response = yield call(api.addController, payload);
  const result = responseParser(response, "", "", true, true);
  if (result) {
    yield put({ type: SET_NEW_CONTROLLER, payload: result });
  }
}

function* updateController({ payload }) {
  const response = yield call(api.updateController, payload);
  const result = responseParser(response, "", "", true, true);
  if (result) {
    yield put({ type: SET_UPDATE_CONTROLLER, payload: result });
  }
}

function* getInvoice() {
  const response = yield call(api.fetchInvoice);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_INVOICE, payload: result });
  }
}

function* adminFactoryReset({ payload }) {
  const response = yield call(api.adminFactoryResetController, payload);
  responseParser(response, "Internal Error", null, true, true);
  yield call(getUserController);
}

export function* combinedSagas() {
  yield all([
    yield takeLatest(FETCH_USERS, getUsers),
    yield takeLatest(FETCH_CONTROLLERS, getController),
    yield takeLatest(FETCH_USER_CONTROLLERS, getUserController),
    yield takeLatest(UPDATE_OTA, updateControllerOta),
    yield takeLatest(ADD_CONTROLLER, addController),
    yield takeLatest(UPDATE_CONTROLLER, updateController),
    yield takeLatest(FETCH_INVOICE, getInvoice),
    yield takeLatest(FACTORY_RESET, adminFactoryReset),
  ]);
}
